var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6277 2.21899H1.73881C1.53554 2.21899 1.37076 2.38464 1.37076 2.58897V7.02864C1.37076 7.23297 1.53554 7.39861 1.73881 7.39861H7.6277C7.83097 7.39861 7.99576 7.23297 7.99576 7.02864V2.58897C7.99576 2.38464 7.83097 2.21899 7.6277 2.21899Z",
    stroke: "currentColor",
    strokeWidth: 0.736111,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37073 2.77393L4.68323 4.80877L7.99573 2.77393",
    stroke: "currentColor",
    strokeWidth: 0.736111,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineEmail);
export default __webpack_public_path__ + "static/media/line-email.61e5ff6d3b764561bec34ff842ae5fc1.svg";
export { ForwardRef as ReactComponent };